import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {
	ROOT_ADMINISTRATION,
	ROOT_AUTHORITY,
	ROOT_CLAIMS,
	ROOT_CONTRACT_CLOSING,
	ROOT_DELIVERY,
	ROOT_FLOTTA_POOL,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_NOTIFICATION_CENTER,
	ROOT_PROFILE,
	ROOT_TYRES,
	ROOT_USER_CHANGE,
	ROOT_BOOKINGS,
	ROOT_MOBILITY,
	ROOT_CARGOS
} from '../../app-routing-roots';
import {PermissionService} from '@shared/service/permission.service';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import { getURLPath } from '@shared/utilities/utilities-function';

// Messa qui perché viene utilizzata in un contenuto statico
export enum Module {
	AUTHORITY 								     = 'authority',
	CLAIMS 										     = 'claims',
	CONTRACT_CLOSING 					     = 'contract-closing',
	NOTIFICATION_CENTER 			     = 'notification-center',
	DELIVERY 									     = 'delivery',
	PROFILE 									     = 'profile',
	TYRES 										     = 'tyres',
	LOGISTICS 								     = 'logistics',
	USER_CHANGE 							     = 'user-change',
	ADMINISTRATION 						     = 'administration',
	INVOICING 								     = 'invoicing',
	FLOTTA_POOL 							     = 'flotta-pool',
	BOOKINGS 									     = 'bookings',
	SHARED 										     = 'shared',
	MOBILITY				    			     = 'mobility',

	// purtroppo a BE il modulo si chiama ADMINISTRATION_USER_MANAGEMENT
	// devo aggiungere per gestire questa inconsistenza
	ADMINISTRATION_USER_MANAGEMENT = 'administration_user_management',
	ADMINISTRATION_RULES 					 = 'administration_rules',
	ADMINISTRATION_CHANNELING 		 = 'administration_channeling',	
  BOOKINGS_RELIEF     					 = 'bookings-relief',
  BOOKINGS_PRELEASE   					 = 'bookings-prelease',
	
	// da be arriva il valore change-user, mentre su FE il modulo è mappato come userchange
  USER_CHANGE_FROM_BE   				 = 'change-user', 
	CARGOS												 = 'cargos'
}

@Injectable({
	providedIn: 'root'
})
export class ModuleService {	

	/*
	 * 	Refactoring Parziale
	 */ 
	private static rootLocation2ProfileMap: { [key: string]: Module } = {
		[ROOT_CLAIMS]:							Module.CLAIMS,
		[ROOT_AUTHORITY]:						Module.AUTHORITY,
		[ROOT_CONTRACT_CLOSING]:		Module.CONTRACT_CLOSING,
		[ROOT_ADMINISTRATION]:			Module.ADMINISTRATION_USER_MANAGEMENT,
		[ROOT_DELIVERY]:						Module.DELIVERY,
		[ROOT_INVOICING]:						Module.INVOICING,
		[ROOT_LOGISTICS]:						Module.LOGISTICS,
		[ROOT_NOTIFICATION_CENTER]:	Module.NOTIFICATION_CENTER,
		[ROOT_PROFILE]:							Module.PROFILE,
		[ROOT_TYRES]:								Module.TYRES,
		[ROOT_USER_CHANGE]:					Module.USER_CHANGE,
		[ROOT_FLOTTA_POOL]:					Module.FLOTTA_POOL,
		[ROOT_BOOKINGS]:						Module.BOOKINGS,
		[ROOT_MOBILITY]:						Module.MOBILITY,
		['relief']:								  Module.BOOKINGS_RELIEF,
		['prelease']:							  Module.BOOKINGS_PRELEASE,
		[ROOT_CARGOS]: 							Module.CARGOS
	};

	public static getCurrentModule(): Module {
		return ModuleService.getModuleByURL( getURLPath() );
	}
	
	public static getModuleByURL(url: string): Module {		
		try {
			// const module: string = getURLPath().split('/')[0];
			// let secondary: string;
			// if(getURLPath().split('/').length > 1){
			// 	secondary = getURLPath().split('/')[1];
			const module: string = url.split('/')[0];
			let secondary: string;
			if(url.split('/').length > 1){
				secondary = url.split('/')[1];
			}
			if(secondary == 'user-management'){
				return Module.ADMINISTRATION_USER_MANAGEMENT;
			}
			if (module === ModuleService.rootLocation2ProfileMap[ROOT_BOOKINGS]) {
				return ModuleService.rootLocation2ProfileMap[url.split('/')[1]];
			}
			
			return ModuleService.rootLocation2ProfileMap[module];
			
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	// ------------------------------------------------------------

	private modules: { [key: string]: Module } = {
		[ROOT_CLAIMS]: Module.CLAIMS,
		[ROOT_AUTHORITY]: Module.AUTHORITY,
		[ROOT_CONTRACT_CLOSING]: Module.CONTRACT_CLOSING,
		[ROOT_ADMINISTRATION]: Module.ADMINISTRATION,
		[ROOT_DELIVERY]: Module.DELIVERY,
		[ROOT_INVOICING]: Module.INVOICING,
		[ROOT_LOGISTICS]: Module.LOGISTICS,
		[ROOT_NOTIFICATION_CENTER]: Module.NOTIFICATION_CENTER,
		[ROOT_PROFILE]: Module.PROFILE,
		[ROOT_TYRES]: Module.TYRES,
		[ROOT_USER_CHANGE]: Module.USER_CHANGE,
		[ROOT_FLOTTA_POOL]:Module.FLOTTA_POOL,
		[ROOT_BOOKINGS]:Module.BOOKINGS,
		[ROOT_MOBILITY]: Module.MOBILITY,
		[ROOT_CARGOS]:Module.CARGOS
	};

	constructor(
		private location: Location,
		private appConfig: AppConfigEnvironmentService,
		private permissionService: PermissionService,
	) {
	}

	// i metodi dovevano essere statici!!
	// e non c'era bisogno di creare un service
	// da service non riesco ad usarlo in una classe Model

	getCurrentModule(): Module {
		const module: string = this.location.path().split('/')[1];

		// bisogna utilizzare ModuleServicerootLocation2ProfileMap() e va tolto this.modules perché è ridondante!
		if (!!this.modules[module]) {
			return this.modules[module];
		}
	}

	getCurrentUserModules(): Module[] {
		const currentModules: Module[] = [];
		
		// il profilo doveva essere passato come argomento!!
		// vedere SRP Single-Responsibility Principle
		this.permissionService.getCurrentUserPermissions().profiles.forEach(profile => {
			if (!!this.modules[profile.module.key]) {
				currentModules.push(this.modules[profile.module.key]);
			}
		});
		return currentModules;
	}
}
